import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../../app";
import { Api } from "../../app-api";
import { ProgramEnum } from "../../app-models";
import { Region } from "../../app-models";
import { ViewModel as root } from "../register";

const mapPin: string = Api.GetUrl("images/mappin.png");

export enum ActvityEnum {
    Bike = 1,
    Swim = 2,
    Sport = 3,
    BikeSwim = 4,
    BikeSport = 5,
    Trail = 6
}

export enum FormEnum {
    Locations = 1,
    SkillLevels = 2,
    Allocations = 3
}

export class Program {
    id: number;
    name: string;
    sort: number;

    bgCss: string;
    textCss: string;

    constructor(data: any) {
        let self = this;

        self.id = data.id;
        self.name = data.name;
        self.sort = data.sort;

        self.bgCss = App.programBgCss(self.id);
        self.textCss = App.programTextCss(self.id);
    }
}

export class Activity {
    id: number;
    bgColour: string;
    name: string;
    programs: Program[];

    bgActiveColour: ko.PureComputed<string>;
    selected: ko.Computed<boolean>;

    containsProgram: (id: number) => boolean;
    showInfo: () => void;
    toggle: () => void;

    constructor(data: any, root: root) {
        let self = this;

        self.id = data.id;
        self.bgColour = self.getBgColour(data.id);
        self.name = data.name;
        self.programs = _.chain(data.programs)
            .map(x => new Program(x))
            .sortBy(x => x.sort)
            .value();

        self.bgActiveColour = ko.pureComputed(() => {
            return self.selected() ? "active" : self.bgColour;
        }, self);

        self.selected = ko.computed(() => {
            return _(root.selectedActivities()).any(x => x.id === self.id);
        }, self);

        self.containsProgram = (id: number) => {
            return _(self.programs).any(x => x.id === id);
        }

        self.toggle = () => {
            if (self.selected())
                root.selectedActivities.remove(self);
            else
                root.selectedActivities.push(self);
        }

        self.showInfo = () => {
            Api.GetActivityInfo(self.id)
                .done(results => {
                    App.showInfo(results, self.name);
                });
        }
    }

    private getBgColour(id: number): string {
        switch (+id) {
            case ActvityEnum.BikeSport:
                return "bg-bike-sport";
            case ActvityEnum.BikeSwim:
                return "bg-bike-swim";
            case ActvityEnum.Sport:
                return "bg-sport";
            case ActvityEnum.Swim:
                return "bg-swim";
            case ActvityEnum.Trail:
                return "bg-mountain-bike";
            default:
                return "bg-bike";
        }
    }
}

export class CategoryTime {
    id: number;
    text: string;

    constructor(data: any) {
        let self = this;

        self.id = data.id;
        self.text = data.text;
    }
}

export class Allocation {
    id: string;
    camp: number;
    alternate: boolean;
    categoryTime: CategoryTime;
    dates: string;
    price: string;
    publish: string;
    skillCategory: number;
    spaces: number;

    available: boolean;
    full: boolean;
    open: boolean;
    started: boolean;
    tags: any;

    addTemplate = "add-template";
    scarcityTemplate = "empty-template";
    scarcityText = "";
    program: string;
    programHtml: string;
    skillLevels: string;
    title: string;

    qty = ko.observable(0);
    showAlternate = ko.observable(false);

    filter: (filter: TagGroup[]) => boolean;

    add: () => void;
    minus: () => void;
    toggleShowAlternate: () => void;

    //toJson: () => any;
    availability: () => void;
    waitList: () => void;

    constructor(data: any, private root: root) {
        let self = this;

        self.id = data.camp + '-' + data.categoryTime.id + '-' + data.skillCategory;

        self.camp = data.camp;
        self.alternate = data.alternate;
        self.categoryTime = new CategoryTime(data.categoryTime);
        self.dates = data.dates;
        self.price = data.price;
        self.publish = data.publish;
        self.skillCategory = data.skillCategory;
        self.spaces = data.spaces;

        self.available = data.available;
        self.full = data.full;
        self.open = data.open;
        self.started = data.started;
        self.tags = data.tags;

        if (self.open && self.spaces !== 0 && self.spaces <= 3) {
            self.scarcityTemplate = "scarcity-template";
            const plural = self.spaces === 1 ? " space" : " spaces";
            self.scarcityText = "Hurry, only " + self.spaces + plural + " left!";
        }

        if (!self.open) {
            self.addTemplate = "publish-template";
        }
        else if (self.started) {
            if (self.available)
                self.addTemplate = "started-available-template";
            else if (self.full)
                self.addTemplate = "started-full-template";
        }
        else if (!self.started && self.full) {
            self.addTemplate = "full-waitlist-template";
        }
 
        self.program = _(root.programs).find(x => x.id == data.program).name;
        self.programHtml = root.programsHtml([data.program]);

        self.skillLevels = _.chain(root.selectedSkillLevels())
            .filter(x => x.category == data.skillCategory)
            .sortBy(x => x.sort)
            .pluck("name")
            .value()
            .join(", ");

        //console.log('data.location: ' + data.location);

        _(root.chooseLocations().locations()).each(x => {
            _(x.locations).each(y => {
                //console.log('location: ' + y.id);
                if (y.id === data.location)
                    self.title = y.name;
            })
        });

        if (!self.title)
            self.title = "Location Name Not Found";

        self.filter = (filter: TagGroup[]) => {
            let result = true;

            _(filter).each(g => {
                result = result && _.chain(g.tags())
                    .filter(t => t.selected())
                    .any(t => _(self.tags).any((x:any) => x.group === g.name && x.value === t.value))
                    .value();
            });

            return result;
        }

        // 0 <= newVal <= spaces
        self.add = () => {
            const newVal = self.qty() + 1;
            self.qty(newVal <= self.spaces ? newVal : self.spaces);
        }

        self.minus = () => {
            const newVal = self.qty() - 1;
            self.qty(0 <= newVal ? newVal : 0);
        }

        self.toggleShowAlternate = () => {
            self.showAlternate(!self.showAlternate());
        }

        self.availability = () => {
            Api.GetAvailabilityInfo()
                .done(results => {
                    App.showInfo(results, "Availability");
                });
        }

        self.waitList = () => {
            root.showWaitList(self);
        }
    }

    public toJson() {
        let self = this;

        return {
            camp: self.camp,
            categoryTime: self.categoryTime.id,
            skillCategory: {
                id: self.skillCategory,
                skillLevels: _.chain(self.root.selectedSkillLevels())
                    .filter(y => y.category === self.skillCategory)
                    .map(y => y.id)
                    .value()
            }
        }
    }
}

export class Distance {
    display: string;

    constructor(public value: number, units: string) {
        let self = this;

        self.display = value.toString() + ' ' + units;
    }
}

export class Filled {
    display: ko.PureComputed<boolean>;
    summary: ko.PureComputed<string>;

    show: () => void;

    constructor(public title: string) { }
}

export class FilledSummary {
    activities = ko.observable(new Filled("Programs"));
    displayFilled = ko.observable(false);

    cssStatus: ko.PureComputed<string>;
    display: ko.PureComputed<boolean>;
    summary: ko.PureComputed<string>;

    filled: ko.PureComputed<Filled[]>;

    show: () => void;

    constructor(root: root) {
        let self = this;

        self.activities().display = ko.pureComputed(() => {
            return root.chooseLocations().filled().display();
        }, self);

        self.activities().summary = ko.pureComputed(() => {
            if (!self.activities().display()) { return ""; }

            const temp = _(root.selectedActivities()).any() ?
                root.selectedActivities() :
                root.chooseLocations().filteredActivities();

            return _(temp).pluck("name").join(", ");
        }, self);

        self.cssStatus = ko.pureComputed(() => {
            return self.displayFilled() ? "fa-chevron-up" : "fa-chevron-down";
        }, self);

        self.display = ko.pureComputed(() => {
            if (root.activeForm().equals(root.chooseLocations()) &&
                !_(root.selectedSkillLevels()).any()) { return false; }

            return _(self.filled()).any(x => x.display());
        }, self);
        
        self.filled = ko.pureComputed(() => {
            const results = _.chain(root.allForms())
                .filter(x => x.filled() && x.filled().display())
                .map(x => x.filled())
                .value();

            if (self.activities().display()) { results.unshift(self.activities()); }

            return results;
        }, self);

        self.summary = ko.pureComputed(() => {
            //return _(self.filled()).map(x => x.summary()).join(", ");
            return _(self.filled()).map(x => x.title).join(", ");
        }, self);

        root.activeForm.subscribe(() => {
            self.displayFilled(false);
        });

        self.activities().show = () => {
            root.chooseLocations().show();
        }

        self.show = () => {
            self.displayFilled(!self.displayFilled());
        }
    }
}

export class Tag {
    text: string;
    value: string;
    info: string;

    selected = ko.observable(false);

    status: ko.Computed<string>;

    showInfo: () => void;
    toggle: () => void;

    constructor(data: any, bgColour: string, activity: Activity) {
        let self = this;

        self.text = data.text;
        self.value = data.value;
        self.info = data.info;

        self.status = ko.pureComputed(() => {
            return bgColour + (self.selected() ? " active" : "");
        }, self);

        self.showInfo = () => {
            //console.log(activity.name);
            if (activity)
                activity.showInfo();
            else
                App.showInfo(self.info, self.text);
        }

        self.toggle = () => {
            self.selected(!self.selected());
            //console.log(value + " selected: " + self.selected());
        }
    }
}

export class TagGroup {
    name: string;

    tags = ko.observableArray<Tag>();

    deSelect: () => void;

    constructor(data: any, root: root) {
        let self = this;

        self.name = data.name;

        const findActivity = (value) => {
            let result: Activity = null;

            _(root.activities).forEach(x => {
                const programId = parseInt(value);

                if (x.containsProgram(programId))
                    result = x;
            });

            return result;
        }

        const tags = _.chain(data.tags)
            .sortBy(x => x.sort)
            .map(x => {
                const isProgram = data.name === "program";
                const activity = findActivity(x.value);
                const text = activity ? activity.name : x.value;
                const bgColour = isProgram ? App.programBgCss(x.value) : "filter-date";
                return new Tag({ text: text, value: x.value, info: x.info }, bgColour, activity);
            })
            .value();

        self.tags(tags);

        self.deSelect = () => {
            _(self.tags()).each(x => x.selected(false));
        }
    }
}

export class Filter {
    display = ko.observable(true);
    filter = ko.observable<any>([]);

    enable: ko.Computed<boolean>;
    showClear: ko.Computed<boolean>;

    tagGroups: ko.Computed<TagGroup[]>;
    selected: ko.Computed<TagGroup[]>;

    show: () => void;

    constructor(root: root) {
        let self = this;

        self.enable = ko.pureComputed(() => {
            return _(self.tagGroups()).any();
        }, self);

        self.showClear = ko.pureComputed(() => {
            return _(self.selected()).any();
        }, self);

        self.selected = ko.pureComputed(() => {
            return _(self.tagGroups()).filter(x => _(x.tags()).any(y => y.selected()));
        }, self);

        self.tagGroups = ko.pureComputed(() => {
            return _.chain(self.filter())
                .sortBy((x: any) => x.sort)
                .map(x => new TagGroup(x, root))
                .value();
        }, self);

        self.display.subscribe(newVal => {
            if (!newVal) { _(self.tagGroups()).each(x => x.deSelect()); }
        });

        self.show = () => {
            self.display(!self.display());
        }
    }
}

export class Next {
    enabled: ko.Computed<boolean>;
    cssStatus: ko.Computed<string>;
    selected: ko.Computed<number>;

    next: () => void;

    constructor() {
        let self = this;

        self.cssStatus = ko.pureComputed(() => {
            return self.enabled() ? "bg-light-green" : "btn-disabled";
        }, self);
    }
}

export class Showing {
    showing = ko.observable(0);
    of = ko.observable(0);

    display: ko.Computed<boolean>;

    constructor() {
        let self = this;

        self.display = ko.pureComputed(() => {
            return self.of() > 0;
        }, self);
    }
}

export class Form {
    id: FormEnum;
    heading: string;

    busy = ko.observable(false);
    filled = ko.observable<Filled>();
    next = ko.observable(new Next());
    noResults = ko.observable(false);
    showing = ko.observable(new Showing());
    unFilled = ko.observable<UnFilled>();

    active: ko.Computed<boolean>;

    back: () => void;
    equals: (form: Form) => boolean;
    show: () => void;
    refresh: () => void;

    constructor(root: root) {
        let self = this;

        self.active = ko.pureComputed(() => {
            return root.activeForm() ? root.activeForm().equals(self) : false;
        }, self);

        self.equals = (form: Form) => self.id == form.id;

        self.show = () => {
            if (self.active()) { return; }
            root.activeForm(self);
        }
    }
}

export class Location {
    id: number;
    name: string;
    program: Program;
    region: Region;
    //nameCss: string;
    springBreak: boolean;
    springBreakLabel: string;

    constructor(data: any, program: Program, site: Site) {
        let self = this;

        self.id = data.id;
        self.name = site.name;
        //self.program = _(root.programs).find(x => x.id == data.program);
        self.program = program;
        self.region = site.region;
        self.springBreak = data.springBreak
        //self.nameCss = Program.textCss(self.program.id);

        //Forest Hill - The Bishop Strachan School
        let bss:number = 1584;

        switch (self.program.id) {
            case ProgramEnum.Swim:
            case ProgramEnum.SwimSpring:
                self.springBreakLabel = self.id == bss ? "Spring Lessons Available" : "Spring and Summer Lessons Available";
                break;
            case ProgramEnum.BikeSchool:
                self.springBreakLabel = "Spring Camps Available";
                break;
            default:
                self.springBreakLabel = "Spring and Summer Camps Available";
                break;
        }
    }
}

export class LocationInfo {
    addressHtml: string;
    mapUrl: string;

    locations: any;

    constructor(data: any, programs: Program[]) {
        let self = this;

        let html = data.street1 + "<br />";
        html += data.street2 ? data.street2 + "<br />" : "";
        html += data.city + ", " + data.region + " " + data.postal;

        self.addressHtml = html;
        self.locations = data.locations;
        self.mapUrl = data.mapUrl;

        _(self.locations).each(x => {
            x.name = _(programs).find(y => y.id == x.program).name;
            const temp = x.notes.replace(/<a/gi, '<a class="my-link"');

            //if (temp.indexOf("<a") > 0 && temp.indexOf("target=") == 0)
            //    temp = temp.replace(/<a/gi, '<a target="_blank"');

            x.notes = temp;
        });
    }
}

export class Site {
    id: number;
    region: Region;
    country: string;
    city: string;
    street: string;
    name: string;
    lat: number;
    lng: number;
    locations: Location[];

    activities: Activity[];
    distance: Distance;
    marker: google.maps.Marker;

    distanceText: string;
    infoWindowId: string;

    displayInfo = ko.observable(false);
    enabled = ko.observable(false);
    info = ko.observable<LocationInfo>();

    programsHtml: ko.Computed<string>;

    enable: (activities: number[]) => void
    showInfo: () => void;
    showInfoWindow: () => void;

    constructor(data: any, map: google.maps.Map, root: root) {
        let self = this;

        self.id = data.id;
        self.country = data.country;
        self.region = new Region(data.region);
        self.city = data.city;
        self.name = data.name;
        self.street = data.street;
        self.lat = data.lat;
        self.lng = data.lng;

        const temp: Location[] = [];

        _(data.locations).each(x => {
            const program = _(root.programs).find(p => p.id == x.program);

            if (program)
                temp.push(new Location(x, program, self))
            //else
            //    console.log("no program for location: " + x.id);
         });

        self.locations = temp;

        const programs = _(self.locations).map(x => x.program.id);

        self.activities = root.filterActivities(programs);
        self.distance = new Distance(data.distance, data.units);

        const bullet = " \u2022\ ";
        self.distanceText = self.city + bullet + self.distance.display;

        self.infoWindowId = 'infoWindow' + self.id;

        self.addMarker({ lat: self.lat, lng: self.lng });

        const infoWindow = new google.maps.InfoWindow();

        self.marker.addListener("click", () => {
            self.setContent(infoWindow);
            infoWindow.open(map, self.marker);
        });

        const selectedPrograms = _.chain(root.selectedActivities())
            .map(x => _(x.programs).map(y => y.id))
            .flatten()
            .value();

        self.programsHtml = ko.pureComputed(() => {
            const selected = _.chain(programs)
                .filter(x => _(selectedPrograms).contains(x))
                .unique()
                .value();

            const filtered = _(selected).any() ? selected : programs;

            return root.programsHtml(filtered);
        }, self);

        self.displayInfo.subscribe(newVal => {
            //if (newVal && !self.info()) { self.getInfo(root); }
            if (newVal) { self.getInfo(root); }
        });

        self.enabled.subscribe(newVal => {
            //console.log("enabled " + self.name + ": " + newVal);
            self.marker.setMap(newVal ? map : null);
        });

        self.showInfo = () => {
            self.displayInfo(!self.displayInfo());
        }

        self.enable = (activities: number[]) => {
            const val = _(self.activities).any(x => _(activities).contains(x.id));
            self.enabled(val);
        }
    }

    private addMarker(location) {
        let self = this;

        self.marker = new google.maps.Marker({
            position: location,
            title: self.name,
            icon: { url: mapPin, scaledSize: new google.maps.Size(24, 32) }
        });
    }

    private getInfo(root: root) {
        let self = this;

        const data = {
            activities: _(root.selectedActivities()).map(x => x.id),
            address: self.id
        }

        Api.GetLocationInfo(data)
            .done(results => {
                if (Api.NoResults("No Location Info Result", results)) { return; }
                self.info(new LocationInfo(results, root.programs));
            });
    }

    private setContent(infoWindow: google.maps.InfoWindow) {
        let self = this;

        if (infoWindow.getContent()) { return; }

        const content = document.getElementById(self.infoWindowId);
        //console.log(content);
        infoWindow.setContent(content);
    }
}

export class SkillLevel {
    id: number;
    category: number;
    name: string;
    ageText: string;
    sort: number;
    available: boolean;
    program: Program;
    tags: any;

    activities: Activity[];
    collapseTarget: string;
    collapseTargetRef: string;
    headerLabel: string;
    image: string;

    displayInfo = ko.observable(false);
    info = ko.observable<any>();

    filter: (filter: TagGroup[]) => boolean;

    showInfo: () => void;

    constructor(data: any, root: root) {
        let self = this;

        self.id = data.id;
        self.category = data.category;
        self.name = data.name;
        self.ageText = data.age;
        self.sort = data.sort;
        self.available = data.available;
        self.program = root.getProgram(data.program);
        self.tags = data.tags;

        self.activities = root.filterActivities([data.program]);
        self.collapseTarget = "skillLevelCollapse" + data.id;
        self.collapseTargetRef = "#" + self.collapseTarget;
        self.headerLabel = "skillLevelHeader" + data.id;
        self.image = "https://cdn.pedalheads.com/images/levels/level-" + data.id + ".jpg";

        self.filter = (filter: TagGroup[]) => {
            let result = true;

            _(filter).each(g => {
                result = result && _.chain(g.tags())
                    .filter(t => t.selected())
                    .any(t => _(self.tags).any((x:any) => x.group === g.name && x.value === t.value))
                    .value();
            });

            return result;
        }

        self.displayInfo.subscribe(newVal => {
            if (newVal && !self.info()) { self.getInfo(); }
        });

        self.showInfo = () => {
            self.displayInfo(!self.displayInfo());
        }
    }

    private getInfo() {
        let self = this;

        Api.GetSkillLevelInfo(self.id)
            .done(results => {
                if (Api.NoResults("No Skill Level Info Result", results)) { return; }
                self.info(results);
            });
    }
}

export class SkillLevelGroup {
    program: Program;

    skillLevels: SkillLevel[];

    constructor(data: any, root: root) {
        let self = this;

        self.program = root.getProgram(data.program);
        self.skillLevels = _(data.skillLevels).sortBy((x: SkillLevel) => x.sort);
    }
}

export class UnFilled {
    display: ko.Computed<boolean>;
    constructor(public title: string) { }
}

export class WaitList {
    name = ko.observable<string>();
    phone = ko.observable<string>();
    email = ko.observable<string>();
    camp = ko.observable<string>();
    skillLevels = ko.observable<string>();
    times = ko.observable<string>();

    submit: () => void;

    constructor(private allocation: Allocation, root: root) {
        let self = this;

        self.camp(allocation.title + " " + allocation.dates);
        self.skillLevels(allocation.skillLevels);
        self.times(allocation.categoryTime.text);

        self.submit = () => {
            const data = self.toJson();

            Api.WaitList(data)
                .done(results => {
                    if (results.error) { return App.alertError(results.message); }
                    if (!App.isValid(results.valid)) { return App.alertWarning(results.message); }
                    App.alertSuccess(results.message);
                    root.waitList(null);
                });
        }
    }

    private toJson() {
        let self = this;

        return {
            allocation: self.allocation.toJson(),
            name: self.name(),
            phone: self.phone(),
            email: self.email(),
            camp: self.camp(),
            levels: self.skillLevels(),
            times: self.times()
        }
    }
}